import { createSelector } from "reselect";
import { AppState } from "@shared/interfaces";

const selectFileState = (state: AppState) => state.file;
export const selectFile = () => createSelector(selectFileState, (state) => state.file);
export const selectMappedToAccountFiles = () => createSelector(selectFileState, (state) => state.mappedToAccountFiles);
